module.exports = __webpack_public_path__ + "static/media/04_negro.58479c65.svg";